(() => {
  if (window.DriplockedPopup) { window.DriplockedPopup.init(); return; }
  const controllers = new Map();
  function setup(overlay) {
    const popup = overlay.querySelector('[data-popup]'), button = popup.querySelector('[data-popup-close]');
    const abort = new AbortController(), on = (el, type, fn) => el.addEventListener(type, fn, {signal: abort.signal});
    let focus, overflow, background = [], timer;
    const isTest = popup.dataset.enableTestMode === 'true';
    const success = !!popup.querySelector('[data-popup-success]') && (!location.hash || location.hash === `#${overlay.dataset.popupForm}`);
    const shown = () => { try { return localStorage.getItem('emailPopupShown') === 'true'; } catch { return false; } };
    const hide = (restore = true) => {
      if (!popup.classList.contains('active')) return;
      popup.classList.remove('active'); overlay.classList.remove('active'); popup.inert = true; popup.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = overflow;
      background.forEach(([el, was]) => { el.inert = was; }); background = [];
      if (restore && focus?.isConnected) focus.focus({preventScroll: true});
      if (!isTest) { try { localStorage.setItem('emailPopupShown', 'true'); } catch {} }
    };
    const show = () => {
      if (!overlay.isConnected || popup.classList.contains('active')) return;
      if (document.querySelector('#cart-drawer.open')) { document.addEventListener('cart:close', show, {once: true, signal: abort.signal}); return; }
      window.DriplockedEditorial?.closeMenu(false);
      document.dispatchEvent(new CustomEvent('dl:overlay-open'));
      focus = document.activeElement; overflow = document.documentElement.style.overflow;
      let current = overlay;
      while (current.parentElement && current !== document.body) {
        [...current.parentElement.children].forEach(el => { if (el !== current && !['SCRIPT', 'STYLE', 'LINK'].includes(el.tagName)) { background.push([el, el.inert]); el.inert = true; } });
        current = current.parentElement;
      }
      document.documentElement.style.overflow = 'hidden';
      popup.inert = false; popup.setAttribute('aria-hidden', 'false'); popup.classList.add('active'); overlay.classList.add('active'); button.focus({preventScroll: true});
    };
    on(button, 'click', () => hide()); on(overlay, 'click', event => { if (event.target === overlay) hide(); });
    on(document, 'dl:cart-opening', () => hide(false));
    on(document, 'keydown', event => {
      if (!popup.classList.contains('active')) return;
      if (event.key === 'Escape') { event.preventDefault(); hide(); }
      if (event.key === 'Tab') {
        const nodes = [...popup.querySelectorAll('button,input:not([type=hidden]),a[href]')].filter(el => el.getClientRects().length), first = nodes[0], last = nodes.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    if (success) {
      popup.querySelector('form').hidden = true; popup.querySelector('[data-popup-success-content]').hidden = false;
      show(); timer = setTimeout(() => hide(), 5000);
    } else if (isTest || !shown()) timer = setTimeout(show, 100);
    return () => { hide(false); clearTimeout(timer); abort.abort(); };
  }
  function init() {
    for (const [root, cleanup] of controllers) if (!root.isConnected) { cleanup(); controllers.delete(root); }
    document.querySelectorAll('[data-popup-overlay]').forEach(root => { if (!controllers.has(root)) controllers.set(root, setup(root)); });
  }
  window.DriplockedPopup = {init};
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => { for (const [root, cleanup] of controllers) if (event.target.contains(root)) { cleanup(); controllers.delete(root); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
})();
